import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import './intro.scss';

class IntroPage extends React.Component {
	constructor(props){
		super(props);
		this.state = {
		};
	}
	componentDidMount (){
		const play = this.props.getPlay();
		this.props.showLoading(true);
		//console.log("uid:"+this.props.getUid());
		this.props.ajax("play/new",{uid:this.props.getUid(),lv:play.lv},(res)=>{
			this.props.showLoading(false);
			if( res.ok ){
				this.props.setState({play:res.play});
				this.props.save();
				//console.log("new:");
				//console.log( res.play );
			}
		});
	}


	render (){
		return (
			<div id="intro">
				<div className="title">革命前夜</div>
				<div className="paper">
					<div className="message">
						<p>
							From: <i className="fas fa-sun"></i><br/>
							To: <i className="fas fa-moon"></i><br/>
						</p>
						<p>
							コリー、夜空のコリー、聞こえる？<br/>
							こちらはマリー、ジャバルー市内への潜入に成功、寝心地は最悪。<br/>
						</p>
						<p>
							さっさと終わらせよう。<br/>
							一人でも多くの仲間を送り込んで！<br/>
						</p>
					</div>
				</div>
				<div className="bottom_btns">
					<button
						className="one"
						onClick={()=>this.goBoard()}
					><i className="fas fa-play"></i><br/>次へ</button>
				</div>
			</div>
		)
	}

	goBoard (){
		this.props.setState({mode:"board"});
	}
}

export default IntroPage;